import { useMemo } from 'react'
import ReactLightbox from 'yet-another-react-lightbox'
import Counter from 'yet-another-react-lightbox/plugins/counter'

import { Icon } from '@/shared/ui'

import { Slide } from './slide'

import 'yet-another-react-lightbox/styles.css'
import 'yet-another-react-lightbox/plugins/counter.css'

const NavigationButtonStyle = {
  width: '36px',
  height: '36px',
  borderRadius: '50%',
  border: '1px solid white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  padding: '0',
}

type Props = {
  index: number
  onClose: () => void
  images: string[]
  roomName: string
}

export const Lightbox = ({ index, onClose, images, roomName }: Props) => {
  const isOpen = index >= 0

  const slides = useMemo(() => {
    return images.map(image => ({
      src: image,
    }))
  }, [images])

  return (
    <ReactLightbox
      open={isOpen}
      close={onClose}
      index={index}
      slides={slides}
      className="pointer-events-auto"
      plugins={[Counter]}
      render={{
        slide: props => <Slide {...props} roomName={roomName} />,
        iconPrev: () => (
          <Icon name="arrow-left" size={16} className="text-white" />
        ),
        iconNext: () => (
          <Icon name="arrow-right" size={16} className="text-white" />
        ),
        iconClose: () => <Icon name="close" size={24} className="text-white" />,
      }}
      styles={{
        navigationPrev: {
          ...NavigationButtonStyle,
          left: '12px',
        },
        navigationNext: {
          ...NavigationButtonStyle,
          right: '12px',
        },
        toolbar: {
          marginTop: '4px',
        },
      }}
      counter={{
        container: {
          style: { top: '0', left: '50%', transform: 'translateX(-50%)' },
          className: 'typo-label2',
        },
      }}
    />
  )
}
